<app-alert-v2 #alert></app-alert-v2>
@if (appVersionService.updateState$ | async; as versionState) {
  @if (versionState === 'updating' || versionState === 'reloading' || versionState === 'error') {
    <app-shared-loading
      [phaseLabel]="versionState === 'reloading' ? 'Recargando aplicación' : 'Actualizando aplicación'"
      [message]="versionState === 'error' ? 'No se pudo completar la actualización. Reintenta.' : ''"
      [showRetry]="versionState === 'error'"
      (retry)="retryVersionUpdate()">
    </app-shared-loading>
  } @else if (bootCoordinator.snapshot$ | async; as boot) {
    @if (boot.state === 'booting' || boot.state === 'warming' || boot.state === 'error') {
      <app-shared-loading
        [progress]="boot.progress"
        [phaseLabel]="boot.phaseLabel"
        [message]="boot.state === 'error' ? 'Revisa la conexión y vuelve a intentarlo.' : ''"
        [showRetry]="boot.state === 'error'"
        (retry)="bootCoordinator.retry()">
      </app-shared-loading>
    }
  }
}
<div *ngIf="realtimeCoordinator.permissionPrompt$ | async" class="push-consent-banner">
  <div class="push-consent-copy">
    <strong>Activa notificaciones</strong>
    <span>Recibe alertas de tareas, mensajes y agenda incluso cuando no tengas la app al frente.</span>
  </div>
  <button type="button" class="push-consent-btn" (click)="enablePushNotifications()">Activar</button>
</div>
<div class="app-container">
  <router-outlet></router-outlet>
</div>
